import { useRef, useState } from 'react';
import Portal from '../../../../../components/other/portal';
import Select from 'react-select';
import './styles.scss';
import DatePicker from 'react-datepicker';
import { DATE_PICKER_DATE_FORMAT } from '../../../../../constants';
import ColorPicker from '../../../../../components/other/color-picker';
import DateCalendar from '../../../../../components/calendars/DateCalendar/DateCalendar';

const EditSidebar = ({
  setIsEditSidebarOpen,
  availableUsers,
  setSelectedUser,
  selectedUser,
  sidebarAction,
  setSidebarAction,
  formData,
  selectedCells,
  selectedAssignmentsToDelete,
  setFormData,
  handleSave,
  handleDelete,
  isSavingUser,
}) => {
  const ref = useRef(null);

  const handleClose = () => {
    setIsEditSidebarOpen(false);
    setSidebarAction(null);
    setSelectedUser(null);
  };
  return (
    <Portal>
      <div className="master-schedule-sidebar" ref={ref}>
        <div className="master-schedule-sidebar-header">
          <div className="master-schedule-sidebar-header-title-wrapper">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="2" width="32" height="32" rx="16" fill="#F4EBFF" />
              <rect x="2" y="2" width="32" height="32" rx="16" stroke="#F9F5FF" strokeWidth="4" />
              <g clipPath="url(#clip0_15442_4708)">
                <path
                  d="M17.3335 12.6671H12.6668C12.3132 12.6671 11.9741 12.8076 11.724 13.0577C11.474 13.3077 11.3335 13.6469 11.3335 14.0005V23.3338C11.3335 23.6874 11.474 24.0266 11.724 24.2766C11.9741 24.5267 12.3132 24.6671 12.6668 24.6671H22.0002C22.3538 24.6671 22.6929 24.5267 22.943 24.2766C23.193 24.0266 23.3335 23.6874 23.3335 23.3338V18.6671M22.3335 11.6671C22.5987 11.4019 22.9584 11.2529 23.3335 11.2529C23.7086 11.2529 24.0683 11.4019 24.3335 11.6671C24.5987 11.9324 24.7477 12.2921 24.7477 12.6671C24.7477 13.0422 24.5987 13.4019 24.3335 13.6671L18.0002 20.0005L15.3335 20.6671L16.0002 18.0005L22.3335 11.6671Z"
                  stroke="#7F56D9"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_15442_4708">
                  <rect width="16" height="16" fill="white" transform="translate(10 10)" />
                </clipPath>
              </defs>
            </svg>
            {sidebarAction === 'add' ? 'Add' : sidebarAction === 'delete' ? 'Delete' : 'Edit'}
          </div>
          <button className="btn btn-icon" onClick={handleClose}>
            <i className="icon-icon-x"></i>
          </button>
        </div>
        <div className="master-schedule-sidebar-body">
          <div className="master-schedule-form">
            <div className="form-item">
              <label className="form-label">Name Last Name</label>
              <div className="sidebar-name-select-wrapper">
                <Select
                  isSearchable
                  options={availableUsers}
                  className="form-control-select"
                  classNamePrefix="react-select"
                  value={selectedUser}
                  placeholder="Select employee"
                  onChange={(e) => setSelectedUser(e)}
                />
              </div>
            </div>

            {sidebarAction === 'add' && (
              <>
                <div className="form-item">
                  <label className="form-label">Full or part shift</label>
                  <div className="sidebar-name-select-wrapper">
                    <Select
                      isSearchable={false}
                      options={[
                        { value: 'both_halves', label: 'Full shift' },
                        { value: 'first_half', label: 'First half' },
                        { value: 'second_half', label: 'Second half' },
                      ]}
                      className="form-control-select"
                      classNamePrefix="react-select"
                      value={formData.halfPart}
                      onChange={(e) => setFormData((state) => ({ ...state, halfPart: e }))}
                    />
                  </div>
                </div>
                <div className="form-item">
                  <label className={'form-label'}>Add from date</label>
                  <DateCalendar
                    selectedDate={formData.addFromDate}
                    placeholderText="Select date"
                    shouldCloseOnSelect
                    handleChange={(value) => {
                      setFormData((state) => ({ ...state, addFromDate: value }));
                    }}
                  />
                </div>
                <div className="form-item">
                  <label className="form-label">Notes (optional)</label>
                  <input
                    name="notes"
                    type="text"
                    className="form-control"
                    placeholder="Enter"
                    value={formData.notes}
                    onChange={(e) => setFormData((state) => ({ ...state, notes: e.target.value }))}
                  />
                </div>
                <div className="form-item form-color-wrapper">
                  <div className="form-font-color">
                    <ColorPicker
                      color={formData.fontColor}
                      onChange={(color) => setFormData((state) => ({ ...state, fontColor: color.hex }))}
                      label="Font color"
                      pickerWidth="342px"
                    />
                  </div>
                  <div className="form-font-color">
                    <ColorPicker
                      color={formData.cellColor}
                      onChange={(color) => setFormData((state) => ({ ...state, cellColor: color.hex }))}
                      label="Cell color"
                      pickerWidth="342px"
                    />
                  </div>
                </div>
              </>
            )}

            {sidebarAction === 'delete' && (
              <div className="form-item">
                <label className="form-label">Choose delete option</label>
                <div className="sidebar-name-select-wrapper">
                  <Select
                    isSearchable={false}
                    options={[
                      { value: 'all_repeated_and_single_shifts', label: 'Delete all repeated and single shifts' },
                      { value: 'all_repeated_shifts', label: 'Delete all repeated shifts' },
                      { value: 'specific_shifts', label: 'Delete specified shifts' },
                    ]}
                    className="form-control-select"
                    classNamePrefix="react-select"
                    value={formData.deleteOption}
                    onChange={(e) => setFormData((state) => ({ ...state, deleteOption: e }))}
                  />
                </div>

                <div className="form-item">
                  <label className={'form-label'}>Effective date</label>
                  <DateCalendar
                    selectedDate={formData.effectiveDate}
                    placeholderText="Select date"
                    shouldCloseOnSelect
                    handleChange={(value) => {
                      setFormData((state) => ({ ...state, effectiveDate: value }));
                    }}
                  />
                </div>
              </div>
            )}

            {sidebarAction ? (
              <div className="bottom-buttons">
                <button className="btn btn-outline" onClick={handleClose}>
                  Cancel
                </button>

                {sidebarAction === 'add' ? (
                  <button
                    className="btn "
                    onClick={handleSave}
                    disabled={!selectedUser || !formData.halfPart || !formData.addFromDate || !selectedCells.length || isSavingUser}
                  >
                    {isSavingUser ? 'Saving...' : 'Save'}
                  </button>
                ) : (
                  <button
                    className="btn btn-danger"
                    onClick={handleDelete}
                    disabled={
                      !formData.effectiveDate || (formData.deleteOption?.value === 'specific_shifts' && !selectedAssignmentsToDelete.length)
                    }
                  >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2.5 4.99935H4.16667M4.16667 4.99935H17.5M4.16667 4.99935V16.666C4.16667 17.108 4.34226 17.532 4.65482 17.8445C4.96738 18.1571 5.39131 18.3327 5.83333 18.3327H14.1667C14.6087 18.3327 15.0326 18.1571 15.3452 17.8445C15.6577 17.532 15.8333 17.108 15.8333 16.666V4.99935H4.16667ZM6.66667 4.99935V3.33268C6.66667 2.89065 6.84226 2.46673 7.15482 2.15417C7.46738 1.84161 7.89131 1.66602 8.33333 1.66602H11.6667C12.1087 1.66602 12.5326 1.84161 12.8452 2.15417C13.1577 2.46673 13.3333 2.89065 13.3333 3.33268V4.99935M8.33333 9.16602V14.166M11.6667 9.16602V14.166"
                        stroke="white"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Delete
                  </button>
                )}
              </div>
            ) : (
              <div className="bottom-buttons">
                <button className="btn btn-outline user-add-btn" onClick={() => setSidebarAction('add')} disabled={!selectedUser}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 3V17M3 10H17" stroke="#7F56D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Add
                </button>
                <button className="btn btn-outline user-delete-btn" onClick={() => setSidebarAction('delete')} disabled={!selectedUser}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.5 5.00033H4.16667M4.16667 5.00033H17.5M4.16667 5.00033V16.667C4.16667 17.109 4.34226 17.5329 4.65482 17.8455C4.96738 18.1581 5.39131 18.3337 5.83333 18.3337H14.1667C14.6087 18.3337 15.0326 18.1581 15.3452 17.8455C15.6577 17.5329 15.8333 17.109 15.8333 16.667V5.00033H4.16667ZM6.66667 5.00033V3.33366C6.66667 2.89163 6.84226 2.46771 7.15482 2.15515C7.46738 1.84259 7.89131 1.66699 8.33333 1.66699H11.6667C12.1087 1.66699 12.5326 1.84259 12.8452 2.15515C13.1577 2.46771 13.3333 2.89163 13.3333 3.33366V5.00033M8.33333 9.16699V14.167M11.6667 9.16699V14.167"
                      stroke="#B42318"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Delete
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default EditSidebar;
